import {
    CloseOutlined,
    DownloadOutlined,
    PrinterOutlined, SaveOutlined, SearchOutlined, SendOutlined,
    UndoOutlined, UploadOutlined
} from '@ant-design/icons';
import { KPIPhongBanPagingResponse, KPIThang } from '@app/models/kpi/KPIPhongBan';
import { Button, Col, DatePicker, DatePickerProps, Form, Input, Radio, Row, Space, Table, Tabs, Tag, Upload, UploadFile, UploadProps } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import Column from 'antd/es/table/Column';
import { ArcElement, BarElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, Tooltip } from 'chart.js';
import dayjs, { Dayjs } from 'dayjs';
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import { toast } from 'react-toastify';
import { ContentHeader } from "../../components";
import ModalTextForm from '../../components/modal/ModalTextForm';
import { idQuyDauTu, maChucVu, trangThaiKPI, trangThaiKPITongHop, urlAdmin } from '../../constants';
import { Links } from '../../helpers/Links';
import { menuHelper } from '../../helpers/account';
import { dateCommon, validateMessages } from '../../helpers/common';
import { TaiLieu } from '../../models/nhanvien/TaiLieu';
import { layKPICaNhan, layTongHopKPIThang, pheDuyetTongHopKPI, themTongHopKPIThang, thuHoiTongHopKPI, timKiemDSKPIPhongBan, vanPhongTraLaiKPICaNhan } from '../../services/kpi';
import { xuatBaoCaoTongHopKPI } from '../../services/report';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';
import InBaoCaoKPIPhongBan from '../utils/InBaoCaoKPIPhongBan';
import InKPICaNhan from './InKPICaNhan';
import ModalTongHopLoiViPham from './ModalTongHopLoiViPham';
import TabKetQuaHoanThanh from './TabKetQuaHoanThanh';
import YKienVanPhong from './components/YKienVanPhong';
import ContainerDonViPhuTrach from '../../modules/department/ContainerDonViPhuTrach';
import TrangThaiTag from './TrangThaiTag';
ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement); 
const KPIPhongBan = () => {
    const dispatch = useDispatch();
    const [activeTab, setActiveTab] = useState<string>("1");
    const noiDungMacDinh = "Ban Thanh tra nhân dân đã thực hiện kiểm tra định kỳ trong tháng, người lao động đã chấp hành đúng nội quy, quy định của Quỹ.";
    let defaultNoiDung = noiDungMacDinh;
    const [reloadPage, setReloadPage] = useState<boolean>(true);
    const [isLoadingTable, setIsLoadingTable] = useState<boolean>(false);
    const [chiTietKPICaNhan, setChiTietKPICaNhan] = useState<any>(null);
    const [idDonVi, setIdDonVi] = useState<number>(idQuyDauTu);
    const [tuKhoa, setTuKhoa] = useState<string>("");
    let ngayHienTai = (dayjs()).date() <= 10 ? (dayjs()).subtract(1, 'month') : dayjs();
    let thangHienTai = ngayHienTai.startOf('month').format('DD/MM/YYYY HH:mm:ss');
    const [thangNam, setThangNam] = useState<string>(thangHienTai);
    const [ngayThang, setNgayThang] = useState<Dayjs | null>(ngayHienTai);
    const monthFormat = 'MM/YYYY';
    const thangNamFormat: DatePickerProps['format'] = (value) => `Tháng ${value.format(monthFormat)}`;
    const user = useSelector((state: any) => state.auth.currentUser);
    const [openModalChiTiet, setOpenModalChiTiet] = useState(false);
    const [openModalYKien, setOpenModalYKien] = useState(false);
    const [loading, setLoading] = useState(false);
    const [formDuaYKien] = Form.useForm();
    const [trinhPhoCVP, setTrinhPhoCVP] = useState(false);
    const [tongHopKPI, setTongHopKPI] = useState<KPIThang | null>(null);
    const [trinhLanhDao, setTrinhLanhDao] = useState(false);
    const menu: any = menuHelper.checkMultiPermission([Links.KPI.TongHopKPI]);
    const [confirmModal, setConfirmModal] = useState<any>({});
    const [idKPITraVe, setIdKPITraVe] = useState<number>(0);
    const [lyDoTraLai, setLyDoTraLai] = useState<string>("");
    const [tenKPITraLai, setTenKPITraLai] = useState<string>("");
    const [openModalLoiViPham, setOpenModalLoiViPham] = useState<boolean>(false);
    const [danhsach, setDanhSach] = useState<KPIPhongBanPagingResponse>({
        "data": [],
        "nhanViens": []
    });
    const [idGiamDoc, setIdGiamDoc] = useState<number>(0);
    const [idsTaiLieuXoa, setIdsTaiLieuXoa] = useState<Array<number>>([]);
    const [fileList, setFileList] = useState<UploadFile[]>([]);
    const props: UploadProps = useMemo(() => ({
        onRemove: (file) => {
            if (file.uid.includes("tailieu")) {
                var id = parseInt(file.uid.split("tailieu")[0]);
                setIdsTaiLieuXoa([...idsTaiLieuXoa, id]);
            }
            const index = fileList.indexOf(file);
            const newFileList = fileList.slice();
            newFileList.splice(index, 1);
            setFileList(newFileList);
        },
        beforeUpload: (file) => {
            const maxSize = 20000000; // 20 MB
            if (file.size > maxSize) {
                alert('Tệp tin đính kèm không được vượt quá 20MB');
            } else {
                setFileList([...fileList, file]);
            }
            return false;
        },
        fileList,
    }), [fileList, idsTaiLieuXoa]);

    const layCTKPICaNhan = async (id: number) => {
        dispatch(showLoadingScreen());
        try {
            var chiTiet = await layKPICaNhan(id)
            setChiTietKPICaNhan(chiTiet);
        } catch (error: any) {
            toast.error(error || 'Có lỗi xảy ra');
        }
        dispatch(hideLoadingScreen());
    }

    useEffect(() => {
        if (!chiTietKPICaNhan) return;
        setTimeout(() => {
            printKPICaNhan();
        }, 300);
    }, [chiTietKPICaNhan]);

    useEffect(() => {
        var fileHienTai: any = (tongHopKPI?.dsTaiLieu || []).map((item: TaiLieu) => {
            return {
                uid: item.idTaiLieu + "tailieu",
                name: item.tenTep,
                status: 'done',
                url: urlAdmin + item.duongDan.replace(/\\/g, "/"),
            };
        });
        setFileList(fileHienTai);
    }, [tongHopKPI?.dsTaiLieu]);

    const onChange: DatePickerProps['onChange'] = (date) => {
        var dateStr = date?.startOf('month').format('DD/MM/YYYY HH:mm:ss');
        setNgayThang(date);
        if (dateStr) {
            setThangNam(dateStr);
            timkiem(idDonVi, tuKhoa, dateStr);
            layThongTinKPIThang(date?.startOf('month').format('MM/YYYY') || "");
        } else {
            setThangNam("");
            timkiem(idDonVi, tuKhoa, "");
            setTongHopKPI(null);
        }
    }

    const onChangeDepartment = (e: any) => {
        if (e) {
            setIdDonVi(e.id);
            timkiem(e.id, tuKhoa, thangNam);
        } else {
            setIdDonVi(0);
            setDanhSach({
                "data": [],
                "nhanViens": []
            });
        }
    };

    const layThongTinKPIThang = async (thangNam: string) => {
        setTrinhPhoCVP(false);
        dispatch(showLoadingScreen());
        var rs = await layTongHopKPIThang(thangNam);
        setTongHopKPI(rs);
        if (rs != null) {
            setTrinhPhoCVP(rs.trinhPhoCVP);
        }
        dispatch(hideLoadingScreen());
    }

    const timkiem = async (idDonVi: number, tuKhoa: string, thangNam: string) => {
        try {
            dispatch(showLoadingScreen());
            setIsLoadingTable(true);
            const temp = await timKiemDSKPIPhongBan(idDonVi, tuKhoa, thangNam);
            setDanhSach({
                "data": (temp?.data || []).map((item: any) => {
                    return { ...item, key: item.idKPICaNhan }
                }),
                "nhanViens": (temp?.nhanViens || []).map((item: any) => {
                    return { ...item, key: item.idNhanVien }
                })
            });
            var giamDoc = temp?.nhanViens.find(x => x.maChucVu == maChucVu.giamDoc);
            setIdGiamDoc(giamDoc?.idNhanVien);
            dispatch(hideLoadingScreen());
            setIsLoadingTable(false);
        }
        catch (error: any) {
            dispatch(hideLoadingScreen());
            setIsLoadingTable(false);
        };
    }

    const exportExcel = async () => {
        if (thangNam) {
            dispatch(showLoadingScreen());
            try {
                var request = {
                    "idDonVi": idDonVi,
                    "tuKhoa": tuKhoa,
                    "thoiGian": thangNam,
                    "noiDung": tongHopKPI != null && tongHopKPI.trangThai == trangThaiKPITongHop.pheDuyet ? tongHopKPI.noiDung : defaultNoiDung,
                }
                var response = await xuatBaoCaoTongHopKPI(request);
                let link = document.createElement('a');
                link.download = `BCTongHopKPI.xlsx`;
                let blob = new Blob([response.data], { type: response.data.type });
                link.href = URL.createObjectURL(blob);
                link.click();
                URL.revokeObjectURL(link.href);
            } catch (error: any) {
                toast.error(error || 'Có lỗi xảy ra');
            }
            dispatch(hideLoadingScreen());
        } else {
            toast.error('Vui lòng chọn tháng đánh giá');
        }
    }

    const containerDepartmentProps = {
        isKPI: true,
        donViQuanLy: true,
        onChange: onChangeDepartment,
        value: idDonVi
    }
    const componentRef = React.createRef<any>();
    const inBaoCao = useReactToPrint({
        content: () => componentRef.current,
    });

    const componentRef1 = React.createRef<any>();
    const printKPICaNhan = useReactToPrint({
        content: () => {
            return componentRef1.current
        },
    });
    const onFinish = async (values: any) => {
        try {
            setLoading(true);
            var rq = { ...values, isTrinh: trinhLanhDao, trinhPhoCVP: trinhPhoCVP };
            var rs = await themTongHopKPIThang(rq, fileList, idsTaiLieuXoa);
            setTongHopKPI(rs);
            if (trinhLanhDao) {
                toast.success(`Trình tổng hợp KPI tháng ${values.thangNam} thành công!`);
            } else {
                toast.success(`Lưu tổng hợp KPI tháng ${values.thangNam} thành công!`);
            }
            formDuaYKien.setFieldValue("thangNam", "");
            formDuaYKien.setFieldValue("noiDung", defaultNoiDung);
            setOpenModalYKien(false);
        }
        catch (err: any) {
            toast.error('Đã xảy ra lỗi, lưu không thành công!');
            setOpenModalYKien(false);
        }

        setLoading(false);
    };

    const eventThuHoiTongHopKPI = async () => {
        dispatch(showLoadingScreen());

        try {
            var rs = await thuHoiTongHopKPI(tongHopKPI?.id || 0);
            toast.success("Thu hồi tổng hợp KPI thành công");
            setTongHopKPI(rs);
            setOpenModalYKien(false);
        } catch (e: any) {
            toast.error("Thu hồi tổng hợp KPI không thành công");
        }

        dispatch(hideLoadingScreen());
    }

    const eventPheDuyetTongHopKPI = async (pheDuyet: boolean) => {
        dispatch(showLoadingScreen());
        try {
            var rs = await pheDuyetTongHopKPI({
                id: tongHopKPI?.id || 0,
                isDuyet: pheDuyet
            });
            if (pheDuyet) {
                toast.success("Trình tổng hợp KPI thành công");
            } else {
                toast.success("Trả lại tổng hợp KPI thành công");
            }
            setTongHopKPI(rs);
            setOpenModalYKien(false);
        } catch (e: any) {
            toast.error("Trình/ Trả lại tổng hợp KPI không thành công");
        }

        dispatch(hideLoadingScreen());
    }

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);

        let idDV = +(params.get('idDonVi') || '');
        if (idDV > 0) {
            setIdDonVi(+idDV);
        }
        let thangNamParams = (params.get('thangNam') || '');
        var thangNamDayjs = dateCommon.convertThangNamToDayjs(thangNamParams);
        var dateStr = "";
        if (thangNamDayjs != null) {
            dateStr = thangNamDayjs?.startOf('month').format('DD/MM/YYYY HH:mm:ss');
            setNgayThang(thangNamDayjs);
            setThangNam(dateStr);
        }
        if (reloadPage) {
            setDanhSach({
                "data": [],
                "nhanViens": []
            });
            timkiem(idDV > 0 ? idDV : idDonVi, tuKhoa, dateStr != "" ? dateStr : thangNam);
            layThongTinKPIThang(thangNamDayjs != null ? thangNamParams : ngayThang?.format('MM/YYYY') || "");
            setReloadPage(false);
        }
    }, [reloadPage]);

    const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            timkiem(idDonVi, tuKhoa, thangNam);
        }
    };
    const getTrangThaiKPIThang = (trangThai: number) => {
        var tag = (<Tag color="default"></Tag>);
        switch (trangThai) {
            case trangThaiKPITongHop.khoiTao: tag = (<Tag color="processing">Khởi tạo</Tag>); break;
            case trangThaiKPITongHop.thuHoi: tag = (<Tag color="warning">Thu hồi</Tag>); break;
            case trangThaiKPITongHop.trinhPhoCVP: tag = (<Tag color="purple">Trình phó chánh văn phòng</Tag>); break;
            case trangThaiKPITongHop.phoCVPTraLai: tag = (<Tag color="error">Phó chánh văn phòng từ chối</Tag>); break;
            case trangThaiKPITongHop.trinhCVP: tag = (<Tag color="cyan">Trình chánh văn phòng</Tag>); break;
            case trangThaiKPITongHop.chanhVPTraLai: tag = (<Tag color="error">Chánh văn phòng từ chối</Tag>); break;
            case trangThaiKPITongHop.trinhGiamDoc: tag = (<Tag color="gold">Trình lãnh đạo đơn vị</Tag>); break;
            case trangThaiKPITongHop.giamDocTraLai: tag = (<Tag color="error">Lãnh đạo đơn vị từ chối</Tag>); break;
            case trangThaiKPITongHop.pheDuyet: tag = (<Tag color="success">Duyệt</Tag>); break;
        }
        return tag;
    }
    const checkWidth = () => {
        return (tongHopKPI == null || tongHopKPI?.trangThai == trangThaiKPITongHop.khoiTao || tongHopKPI?.trangThai == trangThaiKPITongHop.thuHoi || tongHopKPI?.trangThai == trangThaiKPITongHop.phoCVPTraLai)
            && menu[Links.KPI.TongHopKPI] && !(user.maChucVu == maChucVu.phoCVP || user.maChucVu == maChucVu.chanhVP) &&
            danhsach?.data.length > 0 && danhsach?.data.some(kpi => kpi.trangThai === trangThaiKPI.trinhLanhDaoDonVi);
    }
    const checkCVTralai = (trangThai: number) => {
        return (tongHopKPI == null || tongHopKPI?.trangThai == trangThaiKPITongHop.khoiTao || tongHopKPI?.trangThai == trangThaiKPITongHop.thuHoi || tongHopKPI?.trangThai == trangThaiKPITongHop.phoCVPTraLai)
            && menu[Links.KPI.TongHopKPI] && !(user.maChucVu == maChucVu.phoCVP || user.maChucVu == maChucVu.chanhVP) &&
            danhsach?.data.length > 0 && trangThai === trangThaiKPI.trinhLanhDaoDonVi;
    }

    const eventTraLaiKPICaNhan = async () => {
        try {
            await vanPhongTraLaiKPICaNhan({
                idKPICaNhan: idKPITraVe,
                lyDo: lyDoTraLai
            });
            toast.success(`Trả lại KPI của nhân viên ${tenKPITraLai} thành công.`);
            setIdKPITraVe(0);
            setTenKPITraLai("");
            setReloadPage(true);
        } catch (error: any) {
            toast.error(error);
            setIdKPITraVe(0);
            setTenKPITraLai("");
        }
    }
    return (<section>
        <ContentHeader title="KPI phòng ban" />
        <Row className="form-group" gutter={8}>
            <Col span={4}>
                <DatePicker
                    changeOnBlur={true}
                    allowClear={false}
                    value={ngayThang}
                    style={{ width: "100%" }}
                    placeholder="Tháng đánh giá"
                    picker="month"
                    format={thangNamFormat}
                    onChange={onChange} />
            </Col>

            <Col span="6">
                <ContainerDonViPhuTrach {...containerDepartmentProps} />
            </Col>
            {activeTab === "2" ?
                <>
                    <Col span={6}>
                        <Input prefix={<SearchOutlined rev="" />} placeholder="Nhập tên, mã nhân viên" onChange={(e) => setTuKhoa(e.target.value)}
                            onKeyPress={handleKeyPress} />
                    </Col>
                    <Col span={8}>
                        <Space>
                            <Button
                                type="primary"
                                icon={<SearchOutlined rev="" />}
                                onClick={() => {
                                    layThongTinKPIThang(ngayThang?.format('MM/YYYY') || "");
                                    timkiem(idDonVi, tuKhoa, thangNam);
                                }}
                            >
                                Tìm kiếm
                            </Button>
                            <Button
                                className="hrm-btn hrm-btn-success"
                                icon={<DownloadOutlined rev="" />}
                                onClick={() => {
                                    exportExcel();
                                }}
                            >
                                Xuất excel
                            </Button>
                            <Button
                                className="hrm-btn hrm-btn-print"
                                icon={<PrinterOutlined rev="" />}
                                onClick={() => {
                                    inBaoCao();
                                }}
                            >
                                In
                            </Button>
                            <Button
                                className="hrm-btn hrm-btn-success"
                                title="Xem tổng hợp lỗi vi phạm"
                                onClick={() => {
                                    setOpenModalLoiViPham(true);
                                }}>
                                Lỗi vi phạm
                            </Button>
                        </Space>
                    </Col>
                </> : <Button
                    type="primary"
                    icon={<SearchOutlined rev="" />}
                    onClick={() => {
                        layThongTinKPIThang(ngayThang?.format('MM/YYYY') || "");
                        timkiem(idDonVi, tuKhoa, thangNam);
                    }}
                >
                    Tìm kiếm
                </Button>}
        </Row>

        {
            idKPITraVe > 0 &&
            <ModalTextForm
                show={idKPITraVe > 0}
                title="Trả lại KPI"
                handleClose={() => setIdKPITraVe(0)}
                handleSave={() => {
                    eventTraLaiKPICaNhan();
                }}
            >
                <Row>
                    <Col span="24">
                        Bạn có muốn <label>Trả lại</label> KPI của <label>{tenKPITraLai}</label> không? Hãy nhập lý do (nếu có):
                    </Col>
                </Row>
                <Row>
                    <Col span="24">
                        <TextArea
                            rows={2}
                            value={lyDoTraLai}
                            onChange={(e) => {
                                setLyDoTraLai(e.target.value);
                            }}
                        />
                    </Col>
                </Row>
            </ModalTextForm>
        }
        <Tabs activeKey={activeTab}
            onChange={(key) => setActiveTab(key)}
            tabBarExtraContent={
                activeTab == "2" && <Row>
                    {(tongHopKPI == null || (tongHopKPI != null && tongHopKPI.trangThai != trangThaiKPITongHop.pheDuyet)) && menu[Links.KPI.TongHopKPI] && danhsach?.data.length > 0 && danhsach?.data.every(kpi => kpi.trangThai === trangThaiKPI.trinhLanhDaoDonVi || kpi.trangThai === trangThaiKPI.lanhDaoDonViTuChoi || kpi.trangThai == trangThaiKPI.pheDuyet) ?
                        (!(user.maChucVu == maChucVu.phoCVP || user.maChucVu == maChucVu.chanhVP) ? <Col span={24}>
                            <Button
                                className="hrm-btn hrm-btn-warning float-right"
                                icon={<SendOutlined rev="" />}
                                onClick={() => {
                                    setTrinhLanhDao(false);
                                    formDuaYKien.setFieldValue("thangNam", ngayThang?.format('MM/YYYY'));
                                    formDuaYKien.setFieldValue("noiDung", tongHopKPI != null ? tongHopKPI?.noiDung : defaultNoiDung);
                                    setOpenModalYKien(true);
                                }}
                            >
                                Văn phòng tổng hợp
                            </Button>
                        </Col> : user.maChucVu == maChucVu.phoCVP ? (tongHopKPI == null || (tongHopKPI != null && !(tongHopKPI.trangThai == trangThaiKPITongHop.khoiTao || tongHopKPI.trangThai == trangThaiKPITongHop.thuHoi || tongHopKPI.trangThai == trangThaiKPITongHop.phoCVPTraLai)))
                            ? <Col span={24}>
                                <Button
                                    className="hrm-btn hrm-btn-warning float-right"
                                    icon={<SendOutlined rev="" />}
                                    onClick={() => {
                                        formDuaYKien.setFieldValue("thangNam", ngayThang?.format('MM/YYYY'));
                                        formDuaYKien.setFieldValue("noiDung", tongHopKPI != null ? tongHopKPI?.noiDung : defaultNoiDung);
                                        setOpenModalYKien(true);
                                    }}
                                >
                                    Văn phòng tổng hợp
                                </Button>
                            </Col>
                            : null // Phó Chánh VP chưa thấy
                            :
                            user.maChucVu == maChucVu.chanhVP ? (tongHopKPI != null && !(tongHopKPI.trangThai == trangThaiKPITongHop.khoiTao || tongHopKPI.trangThai == trangThaiKPITongHop.thuHoi || tongHopKPI.trangThai == trangThaiKPITongHop.trinhPhoCVP || tongHopKPI.trangThai == trangThaiKPITongHop.phoCVPTraLai))
                                ? <Col span={24}>
                                    <Button
                                        className="hrm-btn hrm-btn-warning float-right"
                                        icon={<SendOutlined rev="" />}
                                        onClick={() => {
                                            formDuaYKien.setFieldValue("thangNam", ngayThang?.format('MM/YYYY'));
                                            formDuaYKien.setFieldValue("noiDung", tongHopKPI != null ? tongHopKPI?.noiDung : defaultNoiDung);
                                            setOpenModalYKien(true);
                                        }}
                                    >
                                        Văn phòng tổng hợp
                                    </Button>
                                </Col>
                                : null : // Chánh Vp chưa thấy
                                null)
                        : null
                    }
                </Row>
            }
            items={[
                {
                    key: '1',
                    label: 'Kết quả hoàn thành công việc',
                    children: <TabKetQuaHoanThanh
                            showYKienVanPhong
                            danhsach={danhsach}
                            tongHopKPI={tongHopKPI}
                            menu={menu}
                            user={user}
                            setOpenModalChiTiet={setOpenModalChiTiet}
                            footerElements={
                                <div style={{ marginTop: '12px', fontSize: '12px', color: '#6b7280', display: 'flex', alignItems: 'center', gap: '6px' }}>
                                    {(tongHopKPI == null ||(tongHopKPI != null && tongHopKPI.trangThai != trangThaiKPITongHop.pheDuyet)) &&
                                        menu[Links.KPI.TongHopKPI] && danhsach?.data.length > 0 && danhsach?.data.every((kpi: any) => kpi.trangThai === trangThaiKPI.trinhLanhDaoDonVi || kpi.trangThai === trangThaiKPI.lanhDaoDonViTuChoi || kpi.trangThai == trangThaiKPI.pheDuyet ||kpi.idNhanVien == idGiamDoc) ?
                                        (!(user.maChucVu == "PCVP" || user.maChucVu == "CVP") ? <Col span={24}>
                                            <Button
                                                className="hrm-btn hrm-btn-warning float-right"
                                                icon={<SendOutlined rev="" />}
                                                onClick={() => {
                                                    setTrinhLanhDao(false);
                                                    formDuaYKien.setFieldValue("thangNam", ngayThang?.format('MM/YYYY'));
                                                    formDuaYKien.setFieldValue("noiDung", tongHopKPI != null ? tongHopKPI?.noiDung : noiDungMacDinh);
                                                    setOpenModalYKien(true);
                                                }}
                                            >
                                                Văn phòng tổng hợp
                                            </Button>
                                        </Col> : user.maChucVu == "PCVP" ? (tongHopKPI == null || (tongHopKPI != null && !(tongHopKPI.trangThai == trangThaiKPITongHop.khoiTao || tongHopKPI.trangThai == trangThaiKPITongHop.thuHoi || tongHopKPI.trangThai == trangThaiKPITongHop.phoCVPTraLai)))
                                            ? <Col span={24}>
                                                <Button
                                                    className="hrm-btn hrm-btn-warning float-right"
                                                    icon={<SendOutlined rev="" />}
                                                    onClick={() => {
                                                        formDuaYKien.setFieldValue("thangNam", ngayThang?.format('MM/YYYY'));
                                                        formDuaYKien.setFieldValue("noiDung", tongHopKPI != null ? tongHopKPI?.noiDung : noiDungMacDinh);
                                                        setOpenModalYKien(true);
                                                    }}
                                                >
                                                    Văn phòng tổng hợp
                                                </Button>
                                            </Col>
                                            : null // Phó Chánh VP chưa thấy
                                            :
                                            user.maChucVu == "CVP" ? (tongHopKPI != null && !(tongHopKPI.trangThai == trangThaiKPITongHop.khoiTao || tongHopKPI.trangThai == trangThaiKPITongHop.thuHoi || tongHopKPI.trangThai == trangThaiKPITongHop.trinhPhoCVP || tongHopKPI.trangThai == trangThaiKPITongHop.phoCVPTraLai))
                                                ? <Col span={24}>
                                                    <Button
                                                        className="hrm-btn hrm-btn-warning float-right"
                                                        icon={<SendOutlined rev="" />}
                                                        onClick={() => {
                                                            formDuaYKien.setFieldValue("thangNam", ngayThang?.format('MM/YYYY'));
                                                            formDuaYKien.setFieldValue("noiDung", tongHopKPI != null ? tongHopKPI?.noiDung : noiDungMacDinh);
                                                            setOpenModalYKien(true);
                                                        }}
                                                    >
                                                        Văn phòng tổng hợp
                                                    </Button>
                                                </Col>
                                                : null : null)
                                        : null
                                    }
                                </div>
                            }
                        />
                },
                {
                    key: '2',
                    label: 'Bảng xếp loại',
                    children:
                        <div>
                            {
                                tongHopKPI != null && tongHopKPI.trangThai == trangThaiKPITongHop.pheDuyet &&
                                <div className="card" style={{ padding: '12px 16px', marginBottom: '10px' }}>
                                    <YKienVanPhong tongHopKPI={tongHopKPI} />
                                </div>
                            }
                            <Row gutter={8}>
                                <Col span="24">
                                    <div className="card card-primary">
                                        <Row>
                                            <Col span={24}>
                                                <Table
                                                    loading={isLoadingTable}
                                                    locale={{ emptyText: "Không có dữ liệu" }}
                                                    dataSource={danhsach?.data}
                                                    pagination={false}
                                                    sticky
                                                    scroll={{ x: 1200 }}
                                                >
                                                    <Column title="Tên nhân viên" dataIndex="hoTen" key="hoTen" width="200px" fixed />
                                                    <Column title="Phòng ban" dataIndex="tenDonVi" key="tenDonVi" width="230px" />
                                                    <Column title="Chức vụ" dataIndex="tenChucVu" key="tenChucVu" width="180px" />
                                                    <Column title="TĐG" dataIndex="tuDanhGia" key="tuDanhGia" align="center" />
                                                    <Column title="LĐP" dataIndex="lanhDaoPhong" key="lanhDaoPhong" align="center" />
                                                    <Column title="LĐPT" dataIndex="lanhDaoPhuTrach" key="lanhDaoPhuTrach" align="center" />
                                                    <Column title="LĐĐV" dataIndex="diemDanhGia" key="diemDanhGia" align="center" />
                                                    <Column title="Xếp loại" dataIndex="xepLoai" key="xepLoai" align="center" />
                                                    <Column title="Lỗi năm" dataIndex="tongSoLoi" key="tongSoLoi" />
                                                    <Column title={""} dataIndex="action" key="action" width={checkWidth() ? "165px" : "110px"}
                                                        fixed='right' render={(value: any, record: any) => {
                                                            return <Space className="float-right">
                                                                {checkCVTralai(record.trangThai) &&
                                                                    <Button loading={loading} style={{ padding: '2px 8px', fontSize: '13px', minWidth: '48px' }}
                                                                        className="hrm-btn-delete hrm-btn-sm"
                                                                        onClick={() => {
                                                                            setIdKPITraVe(record.idKPICaNhan);
                                                                            setTenKPITraLai(record.hoTen);
                                                                        }}>
                                                                        Trả lại
                                                                    </Button>
                                                                }
                                                                <Link target="_blank" rel="noopener noreferrer" className="hrm-btn hrm-btn-sm btn-primary" style={{ padding: '2px 8px', fontSize: '13px', minWidth: '28px' }} to={Links.KPI.ChiTietKPI + "?id=" + record.idKPICaNhan}>Xem</Link>
                                                                <Button style={{ fontSize: '13px', minWidth: '16px' }}
                                                                    className="hrm-btn-print"
                                                                    size="small"
                                                                    onClick={() => { layCTKPICaNhan(record.idKPICaNhan); }}
                                                                >In
                                                                </Button>
                                                            </Space>
                                                        }} />
                                                </Table>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                }
            ]} />
        <div style={{ display: 'none' }}>
            <div ref={componentRef} style={{ backgroundColor: 'white' }}>
                <InBaoCaoKPIPhongBan listData={danhsach} idDonVi={idDonVi} tuKhoa={tuKhoa} thangNam={thangNam} noiDung={tongHopKPI != null && tongHopKPI.trangThai == trangThaiKPITongHop.pheDuyet ? tongHopKPI.noiDung : defaultNoiDung} ></InBaoCaoKPIPhongBan>
            </div>
        </div>
        {chiTietKPICaNhan != null &&
            <section style={{ display: 'none' }}>
                <div ref={componentRef1} >
                    <InKPICaNhan KPICaNhan={chiTietKPICaNhan} ></InKPICaNhan>
                </div>
            </section>
        }
        {openModalYKien && <ModalTextForm title={`Văn phòng tổng hợp KPI tháng ${ngayThang?.format('MM/YYYY')}`}
            hideFooter
            show={openModalYKien}
            size="xl"
            handleClose={() => {
                {
                    formDuaYKien.setFieldValue("thangNam", "");
                    formDuaYKien.setFieldValue("noiDung", defaultNoiDung);
                    setOpenModalYKien(false);
                }
            }
            }
        >
            <Form
                layout="vertical"
                validateMessages={validateMessages}
                onFinish={onFinish}
                form={formDuaYKien}
            >
                <Form.Item hidden name="thangNam"><Input /></Form.Item>
                <Row gutter={16}>
                    {
                        tongHopKPI != null &&
                        <Col span="24">
                            <label>Trạng thái:    {getTrangThaiKPIThang(tongHopKPI.trangThai)}</label>
                        </Col>
                    }
                    {(tongHopKPI == null || tongHopKPI?.trangThai == trangThaiKPITongHop.khoiTao || tongHopKPI?.trangThai == trangThaiKPITongHop.thuHoi || tongHopKPI?.trangThai == trangThaiKPITongHop.phoCVPTraLai
                        || (tongHopKPI?.trangThai == trangThaiKPITongHop.chanhVPTraLai && !tongHopKPI?.trinhPhoCVP) && user.id == tongHopKPI?.idNVKhoiTao) ?
                        <>
                            <Col span={24}>
                                <Form.Item
                                    label="Ý kiến của văn phòng:"
                                    name="noiDung"
                                    rules={[{ required: true }]}
                                >
                                    <TextArea rows={4} placeholder="Nội dung" />
                                </Form.Item>
                            </Col>
                            {user.maChucVu != maChucVu.phoCVP &&
                                <Col span={24} style={{ marginBottom: "10px" }}>
                                    <Radio.Group
                                        onChange={(value: any) => {
                                            setTrinhPhoCVP(value.target.value);
                                        }}
                                        value={trinhPhoCVP}
                                    > <Radio value={true}>Trình Phó Chánh Văn Phòng</Radio>
                                        <Radio value={false}>Trình Chánh Văn Phòng</Radio>
                                    </Radio.Group>
                                </Col>
                            }
                            <Col span="24">
                                <Upload {...props}>
                                    <Button icon={<UploadOutlined rev="" />}>Thêm file</Button>
                                </Upload>
                            </Col>
                        </> :
                        <>
                            <Col span={24}>
                                <Form.Item
                                    label="Ý kiến của văn phòng:"
                                    name="noiDung">
                                    <p>{formDuaYKien.getFieldValue("noiDung")}</p>
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <label>File đính kèm:</label>
                                <Upload disabled={true} {...props}>
                                </Upload>
                            </Col>
                        </>
                    }
                </Row>
                <Form.Item className="float-right">
                    <Space className="float-right">
                        {
                            // button của chuyên viên văn phòng
                            !(user.maChucVu == maChucVu.phoCVP || user.maChucVu == maChucVu.chanhVP) ? (tongHopKPI == null || tongHopKPI?.trangThai == trangThaiKPITongHop.khoiTao || tongHopKPI?.trangThai == trangThaiKPITongHop.thuHoi || tongHopKPI?.trangThai == trangThaiKPITongHop.phoCVPTraLai
                                || (tongHopKPI?.trangThai == trangThaiKPITongHop.chanhVPTraLai && !tongHopKPI?.trinhPhoCVP && user.id == tongHopKPI?.idNVKhoiTao)) ?
                                <> <Button type="primary" className="float-right" htmlType="submit" loading={loading} icon=<SaveOutlined rev="" />>
                                    Lưu
                                </Button>
                                    <Button onClick={() => { setTrinhLanhDao(true); }} type="primary" className="float-right" htmlType="submit" loading={loading} icon=<SendOutlined rev="" />>
                                        Lưu & trình
                                    </Button>
                                </>
                                : (tongHopKPI?.trangThai == trangThaiKPITongHop.trinhPhoCVP) ? <Button type="primary"
                                    className="hrm-btn-warning float-right" loading={loading}
                                    icon={<UndoOutlined rev="" />}
                                    onClick={() => {
                                        setConfirmModal({
                                            isShowModal: true,
                                            title: "Thu hồi KPI",
                                            content:
                                                <>Bạn có muốn <label>Thu hồi</label> bảng tổng hợp KPI này không?</>,
                                            onSubmit: eventThuHoiTongHopKPI
                                        });
                                    }}
                                >
                                    Thu hồi
                                </Button> : null : null
                        }
                        {
                            // button lưu, trình của phó chánh văn phòng
                            user.maChucVu == maChucVu.phoCVP ? (tongHopKPI == null || (tongHopKPI != null && tongHopKPI.idNVKhoiTao == user.id && tongHopKPI.trangThai == trangThaiKPITongHop.chanhVPTraLai)) ?
                                <> <Button type="primary" className="float-right" htmlType="submit" loading={loading} icon=<SaveOutlined rev="" />>
                                    Lưu
                                </Button>
                                    <Button onClick={() => { setTrinhLanhDao(true); }} type="primary" className="float-right" htmlType="submit" loading={loading} icon=<SendOutlined rev="" />>
                                        Lưu & trình
                                    </Button>
                                </>
                                : ((tongHopKPI != null && tongHopKPI.idNVKhoiTao == user.id && tongHopKPI.trangThai == trangThaiKPITongHop.trinhCVP)) ? <Button type="primary"
                                    className="hrm-btn-warning float-right" loading={loading}
                                    icon={<UndoOutlined rev="" />}
                                    onClick={() => {
                                        setConfirmModal({
                                            isShowModal: true,
                                            title: "Thu hồi KPI",
                                            content:
                                                <>Bạn có muốn <label>Thu hồi</label> bảng tổng hợp KPI này không?</>,
                                            onSubmit: eventThuHoiTongHopKPI
                                        });
                                    }}
                                >
                                    Thu hồi
                                </Button> : null : null
                        }
                        {
                            // button phê duyệt của phó chánh văn phòng
                            (user.maChucVu == maChucVu.phoCVP && (tongHopKPI?.trangThai == trangThaiKPITongHop.trinhPhoCVP || tongHopKPI?.trangThai == trangThaiKPITongHop.chanhVPTraLai) && tongHopKPI?.trinhPhoCVP) ?
                                <> <Button loading={loading}
                                    className="hrm-btn-delete float-right"
                                    icon={<CloseOutlined rev="" />} onClick={() => {
                                        setConfirmModal({
                                            isShowModal: true,
                                            title: "Trả lại tổng hợp KPI",
                                            content:
                                                <>Bạn có muốn <label>Trả lại</label> bảng tổng hợp KPI này không?</>,
                                            onSubmit: () => { eventPheDuyetTongHopKPI(false) }
                                        });
                                    }}>
                                    Trả lại
                                </Button>
                                    <Button onClick={() => {
                                        setConfirmModal({
                                            isShowModal: true,
                                            title: "Trình tổng hợp KPI",
                                            content:
                                                <>Bạn có muốn <label>Trình</label> bảng tổng hợp KPI này không?</>,
                                            onSubmit: () => { eventPheDuyetTongHopKPI(true) }
                                        });
                                    }} type="primary" className="float-right" loading={loading} icon=<SendOutlined rev="" />>
                                        Trình
                                    </Button>
                                </> : null
                        }
                        {
                            // button của chánh văn phòng
                            (user.maChucVu == maChucVu.chanhVP && (tongHopKPI?.trangThai == trangThaiKPITongHop.trinhCVP || tongHopKPI?.trangThai == trangThaiKPITongHop.giamDocTraLai)) ?
                                <> <Button loading={loading}
                                    className="hrm-btn-delete float-right"
                                    icon={<CloseOutlined rev="" />}
                                    onClick={() => {
                                        setConfirmModal({
                                            isShowModal: true,
                                            title: "Trả lại tổng hợp KPI",
                                            content:
                                                <>Bạn có muốn <label>Trả lại</label> bảng tổng hợp KPI này không?</>,
                                            onSubmit: () => { eventPheDuyetTongHopKPI(false) }
                                        });
                                    }} >
                                    Trả lại
                                </Button>
                                    <Button onClick={() => {
                                        setConfirmModal({
                                            isShowModal: true,
                                            title: "Trình tổng hợp KPI",
                                            content:
                                                <>Bạn có muốn <label>Trình</label> bảng tổng hợp KPI này không?</>,
                                            onSubmit: () => { eventPheDuyetTongHopKPI(true) }
                                        });
                                    }}
                                        type="primary" className="float-right" loading={loading} icon=<SendOutlined rev="" />>
                                        Trình
                                    </Button>
                                </> : null
                        }
                    </Space>
                </Form.Item>
            </Form>
        </ModalTextForm>}
        <ModalTextForm
            size={"lg"}
            show={confirmModal.isShowModal}
            title={confirmModal.title}
            handleClose={() => setConfirmModal({ isShowModal: false })}
            handleSave={() => {
                confirmModal.onSubmit();
                setConfirmModal({ isShowModal: false });
            }}
        >
            {confirmModal.content}
        </ModalTextForm>
        <ModalTextForm
            dialogClassName={"modal-80wh"}
            show={openModalChiTiet.isShowModal}
            title={
                <>
                    Chi tiết kết quả tự đánh giá trong tháng
                    {openModalChiTiet.tenDonVi ? <span> - <strong>{openModalChiTiet.tenDonVi}</strong></span> : ''}
                </>
            }
            handleClose={() => setOpenModalChiTiet({ isShowModal: false, data: [] })}
            hideFooter
        >
            <Row>
                <Col span={24}>
                    <Table
                        loading={isLoadingTable}
                        locale={{ emptyText: "Không có dữ liệu" }}
                        dataSource={openModalChiTiet?.data}
                        pagination={false}
                        sticky
                        scroll={{ x: 1000 }}
                    >
                        <Column title="Tên nhân viên" dataIndex="hoTen" key="hoTen" width="200px" fixed />
                        <Column title={
                            <span style={{
                                fontWeight: 700,
                                color: '#1e40af'
                            }}>
                                Kết quả công việc
                            </span>
                        }>
                            <Column title="Trước" width="65px" dataIndex="truoc" key="truoc" align="center"
                                render={(_, record) => record.truoc} />
                            <Column title="Đúng" width="65px" dataIndex="dung" key="dung" align="center" render={(_, record) => record.dung} />
                            <Column title="Đang TH" width="65px" dataIndex="dangThucHien" key="dangThucHien" align="center" render={(_, record) => record.dangThucHien} />
                            <Column title="Trễ" width="65px" dataIndex="tre" key="tre" align="center" render={(_, record) => record.tre} />
                        </Column>
                        <Column title="Điểm cộng" width="74px" dataIndex="diemCong" key="diemCong" align="center"
                            render={(_, i) => i.lanhDaoPhuTrachDiemCong > 0 ? i.lanhDaoPhuTrachDiemCong : i.lanhDaoPhongDiemCong > 0 ? i.lanhDaoPhongDiemCong : i.tuDanhGiaDiemCong}
                        />
                        <Column title={
                            <span style={{
                                fontWeight: 700,
                                color: '#1e40af'
                            }}>
                                Điểm đánh giá
                            </span>
                        }>
                            <Column title="TĐG" width="65px" dataIndex="tuDanhGia" key="tuDanhGia" align="center" />
                            <Column title="LĐP" width="65px" dataIndex="lanhDaoPhong" key="lanhDaoPhong" align="center" />
                            <Column title="LĐPT" width="72px" dataIndex="lanhDaoPhuTrach" key="lanhDaoPhuTrach" align="center" />
                            <Column title="LĐĐV" width="74px" dataIndex="diemDanhGia" key="diemDanhGia" align="center" />
                        </Column>
                        <Column
                            title="Xếp loại"
                            width="74px"
                            key="xepLoai"
                            align="center"
                            render={(_, record) => record.xepLoai || record.xepLoaiDuKien}
                        />
                        <Column title="Lỗi năm" width="74px" dataIndex="tongSoLoi" key="tongSoLoi" align="center" />
                        <Column title="TT" width="48px" dataIndex="trangThai" key="trangThai" align="center" render={(value, record) => {
                            return <TrangThaiTag value={record.trangThai} noText/>
                        }} />
                        <Column title="Thao tác" dataIndex="action" key="action" width={checkWidth() ? "156px" : "80px"}
                            fixed='right' render={(value: any, record: any) => {
                                return <Space className="float-right">
                                    {checkCVTralai(record.trangThai) &&
                                        <Button loading={loading} style={{ padding: '2px 8px', fontSize: '13px', minWidth: '48px' }}
                                            className="hrm-btn-delete hrm-btn-sm" title="Trả lại"
                                            onClick={() => {
                                                setIdKPITraVe(record.idKPICaNhan);
                                                setTenKPITraLai(record.hoTen);
                                            }}>
                                            Trả
                                        </Button>
                                    }
                                    <Link target="_blank" style={{ padding: '2px 8px', fontSize: '13px', minWidth: '28px' }}
                                        rel="noopener noreferrer"
                                        className="hrm-btn hrm-btn-sm btn-primary" to={Links.KPI.ChiTietKPI + "?id=" + record.idKPICaNhan}>Xem</Link>
                                    <Button style={{ padding: '2px 8px', fontSize: '13px', minWidth: '16px' }}
                                        className="hrm-btn-print"
                                        size="small"
                                        onClick={() => { layCTKPICaNhan(record.idKPICaNhan); }}
                                    >In
                                    </Button>
                                </Space>
                            }} />
                    </Table>
                </Col>
            </Row>
        </ModalTextForm>
        <ModalTongHopLoiViPham
            show={openModalLoiViPham}
            thangNam={thangNam}
            onClose={() => setOpenModalLoiViPham(false)}
        />
    </section>
    );
};

export default KPIPhongBan;
